import { rHandler } from '@/plugins/RHandler';

// Обертка методов из сервисов с обработчиком rHandler
export const withRHandler = (servicesObject) =>
  Object.entries(servicesObject).reduce((acc, [methodName, method]) => {
    if (typeof method === 'object' && method !== null) {
      acc[methodName] = withRHandler(method);
      return acc;
    }

    if (typeof method === 'function') {
      acc[methodName] = (
        {
          // any[] - arguments of method, eg id
          args = [],
          // object - payload data
          data,
          // object - query objects
          params,
          // ValidationObserver
          obs,
        } = { args: [] },
      ) =>
        rHandler(
          method(...args, data || params),
          (response) => ({ response }),
          (error) => ({ error }),
          obs,
        );
      return acc;
    }

    return acc;
  }, {});
